import React, { useState } from 'react'
import {
  Box,
  Button,
  Collapse,
  Divider,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Code as CodeIcon } from '@material-ui/icons'
import { Loader as LoaderIcon } from 'react-feather'

import BannerHeadCard from '../../../BannerHeadCard'
import { CompilationDetailsCard } from '../index'
import AgeGateCode from '../../../BannerInstallationCard/components/AgeGateCode'
import { AgeGateSourceCodeDialog } from '../../../BannerInstallationCard/components'

import useCookieBanner from 'hooks/useCookieBanner'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'
import styles from './styles'
import theme from 'theme'

const AgeGateCompilationCard = () => {
  const {
    ageGate,
    banner,
    isAgeGateCompiling,
    setIsAgeGateCompiling,
    refreshAgeGate,
  } = useCookieBanner()
  const snackbar = useSnackbar()

  const useStyles = styles(isAgeGateCompiling)
  const classes = useStyles()

  const build = ageGate?.build
  const ageGateToken = ageGate?.token

  const buildCompleted =
    build?.status === constants.cookies.build.COMPLETED_BUILD_STATUS_ID
  const buildInitiated =
    isAgeGateCompiling ||
    build?.status === constants.cookies.build.INITIATED_BUILD_STATUS_ID

  const canSeeCode = !buildInitiated && buildCompleted

  const [openAgeGateCode, setOpenAgeGateCode] = useState(
    buildCompleted || false,
  )
  const [openAgeGateSourceCodeDialog, setOpenAgeGateSourceCodeDialog] =
    useState(false)

  const handleCompile = async () => {
    setIsAgeGateCompiling(true)
    try {
      await service.cookies.ageGate.compile({ bannerId: banner?.id })
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      refreshAgeGate()
    }
  }

  return (
    <Paper variant="outlined">
      <BannerHeadCard name="Controle de Idade" />
      <Divider />
      <Box
        p={2}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        <CompilationDetailsCard build={build} />
        <Box
          bgcolor={theme.palette.custom.light}
          borderRadius={1}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(3)}
          p={2}
          textAlign="justify"
        >
          <Typography color="primary" textAlign="justify">
            Para instalar o Age Gate, copie o código HTML abaixo e adicione-o no
            seu site conforme as instruções de instalação.
          </Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          <Box className={classes.buttonBox}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setOpenAgeGateSourceCodeDialog(true)}
            >
              Como instalar com HTML
            </Button>
          </Box>
          <Box className={classes.buttonBox}>
            <Tooltip
              title={
                (!canSeeCode &&
                  'O código do Age Gate só pode ser mostrado após a compilação ter sido realizada com sucesso.') ||
                ''
              }
            >
              <span className={classes.tooltipSpan}>
                <Button
                  startIcon={<CodeIcon size={18} />}
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpenAgeGateCode(!openAgeGateCode)}
                  disabled={!canSeeCode}
                >
                  Ver código
                </Button>
              </span>
            </Tooltip>
          </Box>
          <Box className={classes.buttonBox}>
            <Tooltip
              title={
                buildInitiated ? 'Aguarde a geração do código finalizar.' : ''
              }
            >
              <span className={classes.tooltipSpan}>
                <Button
                  startIcon={
                    <LoaderIcon size={18} className={classes.iconAnimation} />
                  }
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={buildInitiated}
                  onClick={handleCompile}
                >
                  {isAgeGateCompiling ? 'Gerando...' : 'Gerar'}
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Box>
        <Collapse in={openAgeGateCode}>
          <AgeGateCode ageGateToken={ageGateToken} />
        </Collapse>
      </Box>

      <AgeGateSourceCodeDialog
        open={openAgeGateSourceCodeDialog}
        setOpen={setOpenAgeGateSourceCodeDialog}
      />
    </Paper>
  )
}

export default AgeGateCompilationCard
